module.exports = __webpack_public_path__ + "static/media/20.d3e33a17.wav";